import { render, staticRenderFns } from "./layout-button.vue?vue&type=template&id=a3f140e0&"
import script from "./layout-button.vue?vue&type=script&lang=js&"
export * from "./layout-button.vue?vue&type=script&lang=js&"
import style0 from "./layout-button.vue?vue&type=style&index=0&id=a3f140e0&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports